//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '3.8.2'.
//
package de.katoonerie.adapter

import com.apollographql.apollo3.api.Adapter
import com.apollographql.apollo3.api.AnyAdapter
import com.apollographql.apollo3.api.CustomScalarAdapters
import com.apollographql.apollo3.api.NullableStringAdapter
import com.apollographql.apollo3.api.StringAdapter
import com.apollographql.apollo3.api.evaluate
import com.apollographql.apollo3.api.json.JsonReader
import com.apollographql.apollo3.api.json.JsonWriter
import com.apollographql.apollo3.api.list
import com.apollographql.apollo3.api.nullable
import com.apollographql.apollo3.api.obj
import com.apollographql.apollo3.api.possibleTypes
import de.katoonerie.HomepageQuery
import kotlin.Any
import kotlin.String
import kotlin.Unit
import kotlin.collections.List

public object HomepageQuery_ResponseAdapter {
  public object Data : Adapter<HomepageQuery.Data> {
    public val RESPONSE_NAMES: List<String> = listOf("homepageCollection")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        HomepageQuery.Data {
      var _homepageCollection: HomepageQuery.HomepageCollection? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _homepageCollection = HomepageCollection.obj().nullable().fromJson(reader,
              customScalarAdapters)
          else -> break
        }
      }

      return HomepageQuery.Data(
        homepageCollection = _homepageCollection
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: HomepageQuery.Data,
    ): Unit {
      writer.name("homepageCollection")
      HomepageCollection.obj().nullable().toJson(writer, customScalarAdapters,
          value.homepageCollection)
    }
  }

  public object HomepageCollection : Adapter<HomepageQuery.HomepageCollection> {
    public val RESPONSE_NAMES: List<String> = listOf("items")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        HomepageQuery.HomepageCollection {
      var _items: List<HomepageQuery.Item?>? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _items = Item.obj().nullable().list().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return HomepageQuery.HomepageCollection(
        items = _items!!
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: HomepageQuery.HomepageCollection,
    ): Unit {
      writer.name("items")
      Item.obj().nullable().list().toJson(writer, customScalarAdapters, value.items)
    }
  }

  public object Item : Adapter<HomepageQuery.Item> {
    public val RESPONSE_NAMES: List<String> = listOf("backgroundColor", "accentColor", "banner",
        "navigationBarsCollection", "actionsBar", "introduction")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        HomepageQuery.Item {
      var _backgroundColor: HomepageQuery.BackgroundColor? = null
      var _accentColor: HomepageQuery.AccentColor? = null
      var _banner: HomepageQuery.Banner? = null
      var _navigationBarsCollection: HomepageQuery.NavigationBarsCollection? = null
      var _actionsBar: HomepageQuery.ActionsBar? = null
      var _introduction: HomepageQuery.Introduction? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _backgroundColor = BackgroundColor.obj().nullable().fromJson(reader,
              customScalarAdapters)
          1 -> _accentColor = AccentColor.obj().nullable().fromJson(reader, customScalarAdapters)
          2 -> _banner = Banner.obj().nullable().fromJson(reader, customScalarAdapters)
          3 -> _navigationBarsCollection = NavigationBarsCollection.obj().nullable().fromJson(reader,
              customScalarAdapters)
          4 -> _actionsBar = ActionsBar.obj().nullable().fromJson(reader, customScalarAdapters)
          5 -> _introduction = Introduction.obj().nullable().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return HomepageQuery.Item(
        backgroundColor = _backgroundColor,
        accentColor = _accentColor,
        banner = _banner,
        navigationBarsCollection = _navigationBarsCollection,
        actionsBar = _actionsBar,
        introduction = _introduction
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: HomepageQuery.Item,
    ): Unit {
      writer.name("backgroundColor")
      BackgroundColor.obj().nullable().toJson(writer, customScalarAdapters, value.backgroundColor)

      writer.name("accentColor")
      AccentColor.obj().nullable().toJson(writer, customScalarAdapters, value.accentColor)

      writer.name("banner")
      Banner.obj().nullable().toJson(writer, customScalarAdapters, value.banner)

      writer.name("navigationBarsCollection")
      NavigationBarsCollection.obj().nullable().toJson(writer, customScalarAdapters,
          value.navigationBarsCollection)

      writer.name("actionsBar")
      ActionsBar.obj().nullable().toJson(writer, customScalarAdapters, value.actionsBar)

      writer.name("introduction")
      Introduction.obj().nullable().toJson(writer, customScalarAdapters, value.introduction)
    }
  }

  public object BackgroundColor : Adapter<HomepageQuery.BackgroundColor> {
    public val RESPONSE_NAMES: List<String> = listOf("hex")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        HomepageQuery.BackgroundColor {
      var _hex: String? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _hex = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return HomepageQuery.BackgroundColor(
        hex = _hex
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: HomepageQuery.BackgroundColor,
    ): Unit {
      writer.name("hex")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.hex)
    }
  }

  public object AccentColor : Adapter<HomepageQuery.AccentColor> {
    public val RESPONSE_NAMES: List<String> = listOf("hex")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        HomepageQuery.AccentColor {
      var _hex: String? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _hex = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return HomepageQuery.AccentColor(
        hex = _hex
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: HomepageQuery.AccentColor,
    ): Unit {
      writer.name("hex")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.hex)
    }
  }

  public object Banner : Adapter<HomepageQuery.Banner> {
    public val RESPONSE_NAMES: List<String> = listOf("url")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        HomepageQuery.Banner {
      var _url: String? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _url = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return HomepageQuery.Banner(
        url = _url
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: HomepageQuery.Banner,
    ): Unit {
      writer.name("url")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.url)
    }
  }

  public object NavigationBarsCollection : Adapter<HomepageQuery.NavigationBarsCollection> {
    public val RESPONSE_NAMES: List<String> = listOf("items")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        HomepageQuery.NavigationBarsCollection {
      var _items: List<HomepageQuery.Item1?>? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _items = Item1.obj().nullable().list().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return HomepageQuery.NavigationBarsCollection(
        items = _items!!
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: HomepageQuery.NavigationBarsCollection,
    ): Unit {
      writer.name("items")
      Item1.obj().nullable().list().toJson(writer, customScalarAdapters, value.items)
    }
  }

  public object Item1 : Adapter<HomepageQuery.Item1> {
    public val RESPONSE_NAMES: List<String> = listOf("page", "navigationItemsCollection")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        HomepageQuery.Item1 {
      var _page: HomepageQuery.Page? = null
      var _navigationItemsCollection: HomepageQuery.NavigationItemsCollection? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _page = Page.obj().nullable().fromJson(reader, customScalarAdapters)
          1 -> _navigationItemsCollection = NavigationItemsCollection.obj().nullable().fromJson(reader,
              customScalarAdapters)
          else -> break
        }
      }

      return HomepageQuery.Item1(
        page = _page,
        navigationItemsCollection = _navigationItemsCollection
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: HomepageQuery.Item1,
    ): Unit {
      writer.name("page")
      Page.obj().nullable().toJson(writer, customScalarAdapters, value.page)

      writer.name("navigationItemsCollection")
      NavigationItemsCollection.obj().nullable().toJson(writer, customScalarAdapters,
          value.navigationItemsCollection)
    }
  }

  public object Page : Adapter<HomepageQuery.Page> {
    public val RESPONSE_NAMES: List<String> = listOf("name", "url")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        HomepageQuery.Page {
      var _name: String? = null
      var _url: String? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _name = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          1 -> _url = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return HomepageQuery.Page(
        name = _name,
        url = _url
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: HomepageQuery.Page,
    ): Unit {
      writer.name("name")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.name)

      writer.name("url")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.url)
    }
  }

  public object NavigationItemsCollection : Adapter<HomepageQuery.NavigationItemsCollection> {
    public val RESPONSE_NAMES: List<String> = listOf("items")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        HomepageQuery.NavigationItemsCollection {
      var _items: List<HomepageQuery.Item2?>? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _items = Item2.obj().nullable().list().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return HomepageQuery.NavigationItemsCollection(
        items = _items!!
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: HomepageQuery.NavigationItemsCollection,
    ): Unit {
      writer.name("items")
      Item2.obj().nullable().list().toJson(writer, customScalarAdapters, value.items)
    }
  }

  public object Item2 : Adapter<HomepageQuery.Item2> {
    public val RESPONSE_NAMES: List<String> = listOf("tile", "color", "icon")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        HomepageQuery.Item2 {
      var _tile: HomepageQuery.Tile? = null
      var _color: HomepageQuery.Color? = null
      var _icon: HomepageQuery.Icon? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _tile = Tile.obj().nullable().fromJson(reader, customScalarAdapters)
          1 -> _color = Color.obj().nullable().fromJson(reader, customScalarAdapters)
          2 -> _icon = Icon.obj().nullable().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return HomepageQuery.Item2(
        tile = _tile,
        color = _color,
        icon = _icon
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: HomepageQuery.Item2,
    ): Unit {
      writer.name("tile")
      Tile.obj().nullable().toJson(writer, customScalarAdapters, value.tile)

      writer.name("color")
      Color.obj().nullable().toJson(writer, customScalarAdapters, value.color)

      writer.name("icon")
      Icon.obj().nullable().toJson(writer, customScalarAdapters, value.icon)
    }
  }

  public object Tile : Adapter<HomepageQuery.Tile> {
    public val RESPONSE_NAMES: List<String> = listOf("name", "slug")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        HomepageQuery.Tile {
      var _name: String? = null
      var _slug: String? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _name = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          1 -> _slug = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return HomepageQuery.Tile(
        name = _name,
        slug = _slug
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: HomepageQuery.Tile,
    ): Unit {
      writer.name("name")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.name)

      writer.name("slug")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.slug)
    }
  }

  public object Color : Adapter<HomepageQuery.Color> {
    public val RESPONSE_NAMES: List<String> = listOf("hex")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        HomepageQuery.Color {
      var _hex: String? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _hex = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return HomepageQuery.Color(
        hex = _hex
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: HomepageQuery.Color,
    ): Unit {
      writer.name("hex")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.hex)
    }
  }

  public object Icon : Adapter<HomepageQuery.Icon> {
    public val RESPONSE_NAMES: List<String> = listOf("url")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        HomepageQuery.Icon {
      var _url: String? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _url = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return HomepageQuery.Icon(
        url = _url
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: HomepageQuery.Icon,
    ): Unit {
      writer.name("url")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.url)
    }
  }

  public object ActionsBar : Adapter<HomepageQuery.ActionsBar> {
    public val RESPONSE_NAMES: List<String> = listOf("page", "navigationItemsCollection")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        HomepageQuery.ActionsBar {
      var _page: HomepageQuery.Page1? = null
      var _navigationItemsCollection: HomepageQuery.NavigationItemsCollection1? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _page = Page1.obj().nullable().fromJson(reader, customScalarAdapters)
          1 -> _navigationItemsCollection = NavigationItemsCollection1.obj().nullable().fromJson(reader,
              customScalarAdapters)
          else -> break
        }
      }

      return HomepageQuery.ActionsBar(
        page = _page,
        navigationItemsCollection = _navigationItemsCollection
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: HomepageQuery.ActionsBar,
    ): Unit {
      writer.name("page")
      Page1.obj().nullable().toJson(writer, customScalarAdapters, value.page)

      writer.name("navigationItemsCollection")
      NavigationItemsCollection1.obj().nullable().toJson(writer, customScalarAdapters,
          value.navigationItemsCollection)
    }
  }

  public object Page1 : Adapter<HomepageQuery.Page1> {
    public val RESPONSE_NAMES: List<String> = listOf("name", "url")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        HomepageQuery.Page1 {
      var _name: String? = null
      var _url: String? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _name = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          1 -> _url = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return HomepageQuery.Page1(
        name = _name,
        url = _url
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: HomepageQuery.Page1,
    ): Unit {
      writer.name("name")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.name)

      writer.name("url")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.url)
    }
  }

  public object NavigationItemsCollection1 : Adapter<HomepageQuery.NavigationItemsCollection1> {
    public val RESPONSE_NAMES: List<String> = listOf("items")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        HomepageQuery.NavigationItemsCollection1 {
      var _items: List<HomepageQuery.Item3?>? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _items = Item3.obj().nullable().list().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return HomepageQuery.NavigationItemsCollection1(
        items = _items!!
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: HomepageQuery.NavigationItemsCollection1,
    ): Unit {
      writer.name("items")
      Item3.obj().nullable().list().toJson(writer, customScalarAdapters, value.items)
    }
  }

  public object Item3 : Adapter<HomepageQuery.Item3> {
    public val RESPONSE_NAMES: List<String> = listOf("tile", "color", "icon")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        HomepageQuery.Item3 {
      var _tile: HomepageQuery.Tile1? = null
      var _color: HomepageQuery.Color1? = null
      var _icon: HomepageQuery.Icon1? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _tile = Tile1.obj().nullable().fromJson(reader, customScalarAdapters)
          1 -> _color = Color1.obj().nullable().fromJson(reader, customScalarAdapters)
          2 -> _icon = Icon1.obj().nullable().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return HomepageQuery.Item3(
        tile = _tile,
        color = _color,
        icon = _icon
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: HomepageQuery.Item3,
    ): Unit {
      writer.name("tile")
      Tile1.obj().nullable().toJson(writer, customScalarAdapters, value.tile)

      writer.name("color")
      Color1.obj().nullable().toJson(writer, customScalarAdapters, value.color)

      writer.name("icon")
      Icon1.obj().nullable().toJson(writer, customScalarAdapters, value.icon)
    }
  }

  public object Tile1 : Adapter<HomepageQuery.Tile1> {
    public val RESPONSE_NAMES: List<String> = listOf("name", "slug")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        HomepageQuery.Tile1 {
      var _name: String? = null
      var _slug: String? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _name = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          1 -> _slug = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return HomepageQuery.Tile1(
        name = _name,
        slug = _slug
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: HomepageQuery.Tile1,
    ): Unit {
      writer.name("name")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.name)

      writer.name("slug")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.slug)
    }
  }

  public object Color1 : Adapter<HomepageQuery.Color1> {
    public val RESPONSE_NAMES: List<String> = listOf("hex")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        HomepageQuery.Color1 {
      var _hex: String? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _hex = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return HomepageQuery.Color1(
        hex = _hex
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: HomepageQuery.Color1,
    ): Unit {
      writer.name("hex")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.hex)
    }
  }

  public object Icon1 : Adapter<HomepageQuery.Icon1> {
    public val RESPONSE_NAMES: List<String> = listOf("url")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        HomepageQuery.Icon1 {
      var _url: String? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _url = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return HomepageQuery.Icon1(
        url = _url
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: HomepageQuery.Icon1,
    ): Unit {
      writer.name("url")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.url)
    }
  }

  public object Introduction : Adapter<HomepageQuery.Introduction> {
    public val RESPONSE_NAMES: List<String> = listOf("text")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        HomepageQuery.Introduction {
      var _text: HomepageQuery.Text? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _text = Text.obj().nullable().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return HomepageQuery.Introduction(
        text = _text
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: HomepageQuery.Introduction,
    ): Unit {
      writer.name("text")
      Text.obj().nullable().toJson(writer, customScalarAdapters, value.text)
    }
  }

  public object Text : Adapter<HomepageQuery.Text> {
    public val RESPONSE_NAMES: List<String> = listOf("json", "links")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        HomepageQuery.Text {
      var _json: Any? = null
      var _links: HomepageQuery.Links? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _json = AnyAdapter.fromJson(reader, customScalarAdapters)
          1 -> _links = Links.obj().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return HomepageQuery.Text(
        json = _json!!,
        links = _links!!
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: HomepageQuery.Text,
    ): Unit {
      writer.name("json")
      AnyAdapter.toJson(writer, customScalarAdapters, value.json)

      writer.name("links")
      Links.obj().toJson(writer, customScalarAdapters, value.links)
    }
  }

  public object Links : Adapter<HomepageQuery.Links> {
    public val RESPONSE_NAMES: List<String> = listOf("entries", "assets")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        HomepageQuery.Links {
      var _entries: HomepageQuery.Entries? = null
      var _assets: HomepageQuery.Assets? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _entries = Entries.obj().fromJson(reader, customScalarAdapters)
          1 -> _assets = Assets.obj().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return HomepageQuery.Links(
        entries = _entries!!,
        assets = _assets!!
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: HomepageQuery.Links,
    ): Unit {
      writer.name("entries")
      Entries.obj().toJson(writer, customScalarAdapters, value.entries)

      writer.name("assets")
      Assets.obj().toJson(writer, customScalarAdapters, value.assets)
    }
  }

  public object Entries : Adapter<HomepageQuery.Entries> {
    public val RESPONSE_NAMES: List<String> = listOf("block")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        HomepageQuery.Entries {
      var _block: List<HomepageQuery.Block?>? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _block = Block.obj(true).nullable().list().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return HomepageQuery.Entries(
        block = _block!!
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: HomepageQuery.Entries,
    ): Unit {
      writer.name("block")
      Block.obj(true).nullable().list().toJson(writer, customScalarAdapters, value.block)
    }
  }

  public object Block : Adapter<HomepageQuery.Block> {
    public val RESPONSE_NAMES: List<String> = listOf("__typename")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        HomepageQuery.Block {
      var __typename: String? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> __typename = StringAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      check(__typename != null) {
        "__typename was not found"
      }

      var _onContainer: HomepageQuery.OnContainer? = null
      if (possibleTypes("Container").evaluate(customScalarAdapters.adapterContext.variables(), __typename, customScalarAdapters.adapterContext, null)) {
        reader.rewind()
        _onContainer = de.katoonerie.adapter.HomepageQuery_ResponseAdapter.OnContainer.fromJson(reader,
            customScalarAdapters)
      }

      return HomepageQuery.Block(
        __typename = __typename,
        onContainer = _onContainer
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: HomepageQuery.Block,
    ): Unit {
      writer.name("__typename")
      StringAdapter.toJson(writer, customScalarAdapters, value.__typename)

      if (value.onContainer != null) {
        de.katoonerie.adapter.HomepageQuery_ResponseAdapter.OnContainer.toJson(writer,
            customScalarAdapters, value.onContainer)
      }
    }
  }

  public object OnContainer : Adapter<HomepageQuery.OnContainer> {
    public val RESPONSE_NAMES: List<String> = listOf("sys", "name", "textColor", "backgroundColor",
        "borderColor", "mediaCollection", "youTubeVideosCollection")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        HomepageQuery.OnContainer {
      var _sys: HomepageQuery.Sys? = null
      var _name: String? = null
      var _textColor: HomepageQuery.TextColor? = null
      var _backgroundColor: HomepageQuery.BackgroundColor1? = null
      var _borderColor: HomepageQuery.BorderColor? = null
      var _mediaCollection: HomepageQuery.MediaCollection? = null
      var _youTubeVideosCollection: HomepageQuery.YouTubeVideosCollection? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _sys = Sys.obj().fromJson(reader, customScalarAdapters)
          1 -> _name = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          2 -> _textColor = TextColor.obj().nullable().fromJson(reader, customScalarAdapters)
          3 -> _backgroundColor = BackgroundColor1.obj().nullable().fromJson(reader,
              customScalarAdapters)
          4 -> _borderColor = BorderColor.obj().nullable().fromJson(reader, customScalarAdapters)
          5 -> _mediaCollection = MediaCollection.obj().nullable().fromJson(reader,
              customScalarAdapters)
          6 -> _youTubeVideosCollection = YouTubeVideosCollection.obj().nullable().fromJson(reader,
              customScalarAdapters)
          else -> break
        }
      }

      return HomepageQuery.OnContainer(
        sys = _sys!!,
        name = _name,
        textColor = _textColor,
        backgroundColor = _backgroundColor,
        borderColor = _borderColor,
        mediaCollection = _mediaCollection,
        youTubeVideosCollection = _youTubeVideosCollection
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: HomepageQuery.OnContainer,
    ): Unit {
      writer.name("sys")
      Sys.obj().toJson(writer, customScalarAdapters, value.sys)

      writer.name("name")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.name)

      writer.name("textColor")
      TextColor.obj().nullable().toJson(writer, customScalarAdapters, value.textColor)

      writer.name("backgroundColor")
      BackgroundColor1.obj().nullable().toJson(writer, customScalarAdapters, value.backgroundColor)

      writer.name("borderColor")
      BorderColor.obj().nullable().toJson(writer, customScalarAdapters, value.borderColor)

      writer.name("mediaCollection")
      MediaCollection.obj().nullable().toJson(writer, customScalarAdapters, value.mediaCollection)

      writer.name("youTubeVideosCollection")
      YouTubeVideosCollection.obj().nullable().toJson(writer, customScalarAdapters,
          value.youTubeVideosCollection)
    }
  }

  public object Sys : Adapter<HomepageQuery.Sys> {
    public val RESPONSE_NAMES: List<String> = listOf("id")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        HomepageQuery.Sys {
      var _id: String? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _id = StringAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return HomepageQuery.Sys(
        id = _id!!
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: HomepageQuery.Sys,
    ): Unit {
      writer.name("id")
      StringAdapter.toJson(writer, customScalarAdapters, value.id)
    }
  }

  public object TextColor : Adapter<HomepageQuery.TextColor> {
    public val RESPONSE_NAMES: List<String> = listOf("hex")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        HomepageQuery.TextColor {
      var _hex: String? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _hex = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return HomepageQuery.TextColor(
        hex = _hex
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: HomepageQuery.TextColor,
    ): Unit {
      writer.name("hex")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.hex)
    }
  }

  public object BackgroundColor1 : Adapter<HomepageQuery.BackgroundColor1> {
    public val RESPONSE_NAMES: List<String> = listOf("hex")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        HomepageQuery.BackgroundColor1 {
      var _hex: String? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _hex = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return HomepageQuery.BackgroundColor1(
        hex = _hex
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: HomepageQuery.BackgroundColor1,
    ): Unit {
      writer.name("hex")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.hex)
    }
  }

  public object BorderColor : Adapter<HomepageQuery.BorderColor> {
    public val RESPONSE_NAMES: List<String> = listOf("hex")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        HomepageQuery.BorderColor {
      var _hex: String? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _hex = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return HomepageQuery.BorderColor(
        hex = _hex
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: HomepageQuery.BorderColor,
    ): Unit {
      writer.name("hex")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.hex)
    }
  }

  public object MediaCollection : Adapter<HomepageQuery.MediaCollection> {
    public val RESPONSE_NAMES: List<String> = listOf("items")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        HomepageQuery.MediaCollection {
      var _items: List<HomepageQuery.Item4?>? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _items = Item4.obj().nullable().list().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return HomepageQuery.MediaCollection(
        items = _items!!
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: HomepageQuery.MediaCollection,
    ): Unit {
      writer.name("items")
      Item4.obj().nullable().list().toJson(writer, customScalarAdapters, value.items)
    }
  }

  public object Item4 : Adapter<HomepageQuery.Item4> {
    public val RESPONSE_NAMES: List<String> = listOf("title", "url")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        HomepageQuery.Item4 {
      var _title: String? = null
      var _url: String? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _title = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          1 -> _url = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return HomepageQuery.Item4(
        title = _title,
        url = _url
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: HomepageQuery.Item4,
    ): Unit {
      writer.name("title")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.title)

      writer.name("url")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.url)
    }
  }

  public object YouTubeVideosCollection : Adapter<HomepageQuery.YouTubeVideosCollection> {
    public val RESPONSE_NAMES: List<String> = listOf("items")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        HomepageQuery.YouTubeVideosCollection {
      var _items: List<HomepageQuery.Item5?>? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _items = Item5.obj().nullable().list().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return HomepageQuery.YouTubeVideosCollection(
        items = _items!!
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: HomepageQuery.YouTubeVideosCollection,
    ): Unit {
      writer.name("items")
      Item5.obj().nullable().list().toJson(writer, customScalarAdapters, value.items)
    }
  }

  public object Item5 : Adapter<HomepageQuery.Item5> {
    public val RESPONSE_NAMES: List<String> = listOf("name", "videoId")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        HomepageQuery.Item5 {
      var _name: String? = null
      var _videoId: String? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _name = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          1 -> _videoId = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return HomepageQuery.Item5(
        name = _name,
        videoId = _videoId
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: HomepageQuery.Item5,
    ): Unit {
      writer.name("name")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.name)

      writer.name("videoId")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.videoId)
    }
  }

  public object Assets : Adapter<HomepageQuery.Assets> {
    public val RESPONSE_NAMES: List<String> = listOf("block")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        HomepageQuery.Assets {
      var _block: List<HomepageQuery.Block1?>? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _block = Block1.obj().nullable().list().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return HomepageQuery.Assets(
        block = _block!!
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: HomepageQuery.Assets,
    ): Unit {
      writer.name("block")
      Block1.obj().nullable().list().toJson(writer, customScalarAdapters, value.block)
    }
  }

  public object Block1 : Adapter<HomepageQuery.Block1> {
    public val RESPONSE_NAMES: List<String> = listOf("contentType", "sys", "title", "url")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        HomepageQuery.Block1 {
      var _contentType: String? = null
      var _sys: HomepageQuery.Sys1? = null
      var _title: String? = null
      var _url: String? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _contentType = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          1 -> _sys = Sys1.obj().fromJson(reader, customScalarAdapters)
          2 -> _title = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          3 -> _url = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return HomepageQuery.Block1(
        contentType = _contentType,
        sys = _sys!!,
        title = _title,
        url = _url
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: HomepageQuery.Block1,
    ): Unit {
      writer.name("contentType")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.contentType)

      writer.name("sys")
      Sys1.obj().toJson(writer, customScalarAdapters, value.sys)

      writer.name("title")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.title)

      writer.name("url")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.url)
    }
  }

  public object Sys1 : Adapter<HomepageQuery.Sys1> {
    public val RESPONSE_NAMES: List<String> = listOf("id")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        HomepageQuery.Sys1 {
      var _id: String? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _id = StringAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return HomepageQuery.Sys1(
        id = _id!!
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: HomepageQuery.Sys1,
    ): Unit {
      writer.name("id")
      StringAdapter.toJson(writer, customScalarAdapters, value.id)
    }
  }
}
